import { getIn, connect } from 'formik';
import PropTypes from 'prop-types';
import { Component, Fragment } from 'react';
import styled from 'styled-components';

import { AdditionalInformation } from '@hivebrite/design-system/AdditionalInformation';
import { Box } from '@hivebrite/design-system/Box';

import {
  getGiftIndex,
  getCategorizedFunds,
  getHighlightedFunds,
} from 'hb-react/shared/apps/Donations/utils/gifts';
import { withFeatureFlag } from 'hb-react/shared/hooks/useFeatureFlag';

import Fund from '../Fund';

class FundsList extends Component {
  renderFunds = ({ funds, highlight }) => {
    const { formik, handleClickOnFund } = this.props;
    const gifts = getIn(formik.values, 'donation_order[gifts_attributes]');

    return funds.map((fund) => {
      const isSelected =
        getGiftIndex({
          selectedGifts: gifts,
          fundId: fund.id,
        }) > -1;

      return (
        <Fund
          key={fund.id}
          isSelected={isSelected}
          isHighlighted={highlight}
          fund={fund}
          onClick={handleClickOnFund}
        />
      );
    });
  };

  renderSearchedFunds = () => {
    const { searchedFunds } = this.props;

    if (searchedFunds.length < 1) {
      return (
        <Box pl={3} font="body-asphalt-italic">
          {__('No fund match this search.')}
        </Box>
      );
    }

    return this.renderFunds({ funds: searchedFunds });
  };

  renderCategorizedFunds = () => {
    const { funds, categories } = this.props;
    const categorizedFunds = getCategorizedFunds({ funds, categories });
    const highlightedFunds = getHighlightedFunds({ funds });

    return (
      <>
        {this.renderFunds({ funds: highlightedFunds, highlight: true })}
        {categorizedFunds.map((category) => (
          <Fragment key={category.id}>
            <CategoryTitle>{category.name}</CategoryTitle>
            {this.renderFunds({ funds: category.funds })}
          </Fragment>
        ))}
      </>
    );
  };

  render() {
    const { formik, isSearching } = this.props;
    const gifts = getIn(formik.values, 'donation_order[gifts_attributes]');
    const formSubmitted = formik.submitCount > 0;

    return (
      <div className="grid grid--narrow" data-testid="funds-list">
        {isSearching
          ? this.renderSearchedFunds()
          : this.renderCategorizedFunds()}
        {formSubmitted && gifts.length < 1 && (
          <Box ml="10px" display="block">
            <AdditionalInformation type="error" id="fund_list">
              {__('You have to select a fund')}
            </AdditionalInformation>
          </Box>
        )}
      </div>
    );
  }
}

FundsList.propTypes = {
  handleClickOnFund: PropTypes.func.isRequired,
  isSearching: PropTypes.bool.isRequired,
  funds: PropTypes.array,
  searchedFunds: PropTypes.array,
  categories: PropTypes.array,
};

FundsList.defaultProps = {
  funds: [],
  categories: [],
};

export default connect(withFeatureFlag(FundsList));

const CategoryTitle = styled(Box).attrs({
  font: 'body-semibold-asphalt',
  as: 'h6',
  pb: 1,
  my: 3,
  ml: 3,
})`
  border-width: 2px;
  border-bottom: 1px solid #eeeeee;
  letter-spacing: -0.3px;
  text-transform: uppercase;
`;
